import React from 'react';
import { Minus, Plus, Trash2 } from 'lucide-react';
import { CartItem as CartItemType } from '../types';

interface CartItemProps {
  item: CartItemType;
  onUpdateQuantity: (cartItemId: string, quantity: number) => void;
}

export function CartItem({ item, onUpdateQuantity }: CartItemProps) {
  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(price);
  };

  const totalPrice = item.product.price * item.quantity;

  return (
    <div className="bg-white rounded-xl p-4 shadow-md">
      <div className="flex gap-3">
        <img
          src={item.product.image}
          alt={item.product.name}
          className="w-16 h-16 rounded-lg object-cover flex-shrink-0"
        />
        
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-gray-900 truncate">
            {item.product.name}
          </h3>
          <p className="text-sm text-gray-600 mb-2">
            {formatPrice(item.product.price)} each
          </p>
          
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <button
                onClick={() => onUpdateQuantity(item.id, item.quantity - 1)}
                className="p-1 rounded-full hover:bg-gray-100 transition-colors"
              >
                {item.quantity === 1 ? (
                  <Trash2 className="w-4 h-4 text-red-500" />
                ) : (
                  <Minus className="w-4 h-4 text-gray-600" />
                )}
              </button>
              
              <span className="font-medium text-gray-900 min-w-[2rem] text-center">
                {item.quantity}
              </span>
              
              <button
                onClick={() => onUpdateQuantity(item.id, item.quantity + 1)}
                className="p-1 rounded-full hover:bg-gray-100 transition-colors"
              >
                <Plus className="w-4 h-4 text-gray-600" />
              </button>
            </div>
            
            <div className="font-bold text-emerald-600">
              {formatPrice(totalPrice)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}